// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__ELLcB","label":"index_label__8NJc5","label-text":"index_label-text__c1CYI","value":"index_value__jAJuV"};